// import { IsAuthenticated } from '@emyw/auth-lib';
import { log } from '@emyw/core-lib';

const { REACT_APP_FREE_PLAN_CODE: FREE } = process.env;

// const { REACT_APP_FREE_PLAN_CODE: FREE } = process.env;

/** Defines the sequence structure for the wizard using the index to indicate the step.
 * The authAndForward and authAndBack are indicators that if the user is authenticated,
 * which occurs once the account is verified, that if this step becomes active again,
 * it should redirect to the appropriate index depending on if it was activated using
 * the forward or back button on the browser. If it could not be determined if forward or back
 * was used to activate a step, then forward is assumed.
 */
export const wizardPageSequence = {
    '': { index: 0 },
    plan: { index: 1 },
    setupaccount: { index: 2, authAndForward: 'payment', authAndBack: 'plan' },
    newaccount: { index: 3, authAndForward: 'payment', authAndBack: 'plan' },
    verifyaccount: { index: 4, authAndForward: 'payment', authAndBack: 'plan' },
    payment: { index: 5, freeAndForward: 'confirm', freeAndBack: 'plan' },
    cardinfo: { index: 6, freeAndForward: 'confirm', freeAndBack: 'plan', authAndBack: 'payment' },
    paypal: { index: 6, freeAndForward: 'confirm', freeAndBack: 'plan', authAndBack: 'payment' },
    confirm: { index: 7/* , completeAndBack: 'signupcomplete' */ },
};

export const subscriptionProgress = (user) => {
    log.trace('subscriptionProgress:', user);
    if (user && user.signupCompletedOn && user.email === localStorage.getItem('verification-email')) {
        log.trace('verification email equals current user email');
    }
    if (!user || user.signupCompletedOn) {
        // No authenticated user OR user has already completed signup and wants to create new user
        const storedCode = localStorage.getItem('plan-code');
        const verificationEmail = localStorage.getItem('verification-email');
        let progress = localStorage.getItem('enjoy-signup-progress');
        // If there is no progress, check to see if we are verifying an email token, if not then default to plan
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('t')) progress = 'verifyaccount';
        if (!wizardPageSequence[progress]) progress = 'plan';
        if (!storedCode && wizardPageSequence[progress].index > 1 && progress !== 'verifyaccount') {
            // No stored plan is found but progress is somehow past selecting plan (special case for verifyaccount) - bump progress back
            progress = 'plan';
        } else if (wizardPageSequence[progress].index > 4
            || (user && user.signupCompletedOn && user.email === verificationEmail && progress === 'verifyaccount')
        ) {
            const tokenExists = window.location.search !== '';
            if (tokenExists) {
                progress = 'verifyaccount';
            } else {
                // No user is authenticated but progress is somehow past creating/verifying account, or progress is at verify
                // account but verify email equals email of logged in user who's already completed signup - bump progress back
                progress = 'setupaccount';
            }
        }
        localStorage.setItem('enjoy-signup-progress', progress);
        log.trace('progress:', progress);
        return progress;
    }
    const userPlanCode = user.subscriptionLevelCode;
    let progress = 'confirm';
    if (!user.paymentMethod && userPlanCode !== FREE) progress = 'payment';
    if (!user.subscriptionLevelCode) progress = 'plan';
    localStorage.setItem('enjoy-signup-progress', progress);
    return progress;
};

export const ValidateStep = async (location, user) => {
    const path = location.pathname.substr(8);
    const progress = subscriptionProgress(user);
    let directTo = path;
    const userPlanCode = (user || {}).subscriptionLevelCode || localStorage.getItem('plan-code') || FREE;
    if (wizardPageSequence[path].index > wizardPageSequence[progress].index) {
        // Unless progress = payment and path = cardinfo or paypal, some steps were skipped
        if (!(progress === 'payment' && (path === 'cardinfo' || path === 'paypal'))) {
            // Skipped some steps - go back
            directTo = progress;
        }
    } else if (path === 'verifyaccount' && progress !== 'verifyaccount') {
        // User should only be at Verify Account page if that's where progress is at
        // i.e. cannot go back to this step unless user creates another new account
        directTo = progress;
    } else if (path.match('payment|cardinfo|paypal') && userPlanCode === FREE) {
        // If free plan, no need to enter payment info - skip ahead
        directTo = 'confirm';
    }
    // log.trace(`ought to redirect to ${directTo}`);
    return directTo;
    // return IsAuthenticated().then((res) => {
    //     if (!storedCode && wizardPageSequence[progress].index > 1) {
    //         /* No plan is found in storage but progress is somehow past selecting plan; go back */
    //         directTo = 'plan';
    //     } else if (!res && wizardPageSequence[progress].index > 4) {
    //         /* Not authenticated but progress is somehow past creating/verifying account; go back */
    //         directTo = 'setupaccount';
    //     } else if (res && !user.signupCompletedOn && wizardPageSequence[path].index > 2 && wizardPageSequence[path].index < 5) {
    //         /* Already authenticated but trying to recreate or verify account; direct to correct page */
    //         directTo = progress;
    //     } else if (wizardPageSequence[path].index > wizardPageSequence[progress].index) {
    //         /* Unless progress = payment and path = cardinfo or paypal, some steps were skipped */
    //         if (!(progress === 'payment' && (path === 'cardinfo' || path === 'paypal'))) {
    //             /* Skipped some steps; go back */
    //             directTo = progress;
    //         }
    //     }
    //     log.trace(`subscriptionProgress: ${progress}`);
    //     log.trace(`ought to redirect to ${directTo}`);
    //     return directTo;
    // });
};
